// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc8d0a30","239":"2e15e1b8","732":"c3f402ba"}[chunkId] + ".chunk.js";
};